import React from 'react'
import Tree from 'react-d3-tree'

export function TreeRenderer({
                                 loading,
                                 error,
                                 treeData,
                                 zoom,
                                 handleNodeClick,
                                 renderCustomNode,
                                 API_URL,
                             }) {
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#f8f6f2]">
                <div className="flex flex-col items-center gap-4 p-8">
                    <div className="w-16 h-16 border-4 border-[#937c5d] border-t-transparent rounded-full animate-spin" />
                    <div className="text-xl text-[#937c5d]">טוען את עץ המשפחה...</div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#f8f6f2]">
                <div className="max-w-md p-6 bg-white rounded-xl shadow-md border border-[#e6dfd4]">
                    <div className="text-xl text-red-500 font-medium mb-2">שגיאה</div>
                    <div className="text-[#937c5d]">{error}</div>
                </div>
            </div>
        )
    }

    if (!treeData) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#f8f6f2]">
                <div className="max-w-md p-6 bg-white rounded-xl shadow-md border border-[#e6dfd4] text-center">
                    <div className="text-xl text-[#4a3f30] font-medium mb-2">
                        אין נתונים
                    </div>
                    <div className="text-[#937c5d]">לא נמצאו נתונים להצגה</div>
                </div>
            </div>
        )
    }

    return (
        <div className="relative w-full h-screen bg-[#f8f6f2]">
            <div
                className="w-full h-full overflow-hidden transition-transform duration-300"
                style={{
                    transform: `scale(${zoom})`,
                    transformOrigin: 'center top',
                }}
            >
                <Tree
                    data={treeData}
                    orientation="vertical"
                    renderCustomNodeElement={(nodeData) =>
                        renderCustomNode({
                            ...nodeData,
                            API_URL,
                            onClick: (nodeDatum) => {
                                handleNodeClick({
                                    data: nodeDatum,
                                    parent: nodeData.parent,
                                    children: nodeData.children,
                                    depth: nodeData.depth,
                                })
                            },
                        })
                    }
                    pathFunc="step"
                    separation={{ siblings: 2, nonSiblings: 2.5 }}
                    nodeSize={{ x: 340, y: 410 }}
                    translate={{ x: window.innerWidth / 2, y: 150 }}
                    pathClassFunc={() => 'stroke-[#e6dfd4] stroke-2'}
                />
            </div>
        </div>
    )
}